module.exports = __webpack_public_path__ + "img/CITROEN.664c090e.webp";